"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIllustration = _interopRequireDefault(require("../withIllustration"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IllustrationHousesBackground = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
    viewBox: "0 0 1462 159",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("defs", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        id: "path-1",
        x: "24",
        y: "68",
        width: "4",
        height: "4"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        id: "path-2",
        x: "24",
        y: "76",
        width: "4",
        height: "4"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        id: "path-3",
        x: "32",
        y: "68",
        width: "4",
        height: "4"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        id: "path-4",
        x: "32",
        y: "76",
        width: "4",
        height: "4"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        id: "path-5",
        x: "44",
        y: "36",
        width: "4",
        height: "4"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        id: "path-6",
        x: "44",
        y: "44",
        width: "4",
        height: "4"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        id: "path-7",
        x: "44",
        y: "52",
        width: "4",
        height: "4"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        id: "path-8",
        x: "44",
        y: "60",
        width: "4",
        height: "4"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        id: "path-9",
        x: "44",
        y: "68",
        width: "4",
        height: "4"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        id: "path-10",
        x: "44",
        y: "76",
        width: "4",
        height: "4"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        id: "path-11",
        x: "52",
        y: "4",
        width: "4",
        height: "4"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        id: "path-12",
        x: "52",
        y: "12",
        width: "4",
        height: "4"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        id: "path-13",
        x: "52",
        y: "20",
        width: "4",
        height: "4"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        id: "path-14",
        x: "52",
        y: "28",
        width: "4",
        height: "4"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        id: "path-15",
        x: "52",
        y: "36",
        width: "4",
        height: "4"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        id: "path-16",
        x: "52",
        y: "44",
        width: "4",
        height: "4"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        id: "path-17",
        x: "52",
        y: "52",
        width: "4",
        height: "4"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        id: "path-18",
        x: "52",
        y: "60",
        width: "4",
        height: "4"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        id: "path-19",
        x: "52",
        y: "68",
        width: "4",
        height: "4"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        id: "path-20",
        x: "52",
        y: "76",
        width: "4",
        height: "4"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        id: "path-21",
        x: "24",
        y: "68",
        width: "4",
        height: "4"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        id: "path-22",
        x: "24",
        y: "76",
        width: "4",
        height: "4"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        id: "path-23",
        x: "32",
        y: "68",
        width: "4",
        height: "4"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        id: "path-24",
        x: "32",
        y: "76",
        width: "4",
        height: "4"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        id: "path-25",
        x: "44",
        y: "36",
        width: "4",
        height: "4"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        id: "path-26",
        x: "44",
        y: "44",
        width: "4",
        height: "4"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        id: "path-27",
        x: "44",
        y: "52",
        width: "4",
        height: "4"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        id: "path-28",
        x: "44",
        y: "60",
        width: "4",
        height: "4"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        id: "path-29",
        x: "44",
        y: "68",
        width: "4",
        height: "4"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        id: "path-30",
        x: "44",
        y: "76",
        width: "4",
        height: "4"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        id: "path-31",
        x: "52",
        y: "4",
        width: "4",
        height: "4"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        id: "path-32",
        x: "52",
        y: "12",
        width: "4",
        height: "4"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        id: "path-33",
        x: "52",
        y: "20",
        width: "4",
        height: "4"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        id: "path-34",
        x: "52",
        y: "28",
        width: "4",
        height: "4"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        id: "path-35",
        x: "52",
        y: "36",
        width: "4",
        height: "4"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        id: "path-36",
        x: "52",
        y: "44",
        width: "4",
        height: "4"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        id: "path-37",
        x: "52",
        y: "52",
        width: "4",
        height: "4"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        id: "path-38",
        x: "52",
        y: "60",
        width: "4",
        height: "4"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        id: "path-39",
        x: "52",
        y: "68",
        width: "4",
        height: "4"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        id: "path-40",
        x: "52",
        y: "76",
        width: "4",
        height: "4"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        transform: "translate(11.000000, -61.000000)",
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
          transform: "translate(-11.000000, 61.000000)",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M11,67 C34.7750236,67 38.8626593,83 54.712675,83 C70.5626908,83 54.217362,83 77.9923856,83 C101.767409,83 84.9267675,67 110.18773,67 C135.448693,67 118.608051,51 141.887762,51 C165.167472,51 160.173826,51 173.09248,51 C186.011134,51 181.017488,67 204.792512,67 C228.567535,67 228.567535,67 252.342559,67 C276.117583,67 268.192575,83 291.967598,83 C315.742622,83 299.892606,83 323.66763,83 C347.442653,83 331.592638,99 359.330165,99 C387.067693,99 371.217677,99 398.955205,99 C426.692732,99 410.842716,83 434.61774,83 C458.392764,83 442.542748,67 474.242779,67 C505.942811,67 482.167787,67 505.942811,67 C529.717835,67 521.792827,83 545.56785,83 C569.342874,83 545.56785,83 561.417866,83 C577.267882,83 569.342874,99 593.117898,99 C616.892921,99 593.117898,99 608.967913,99 C624.817929,99 616.892921,83 640.667945,83 C664.442968,83 632.742937,83 656.517961,83 C680.292984,83 664.442968,99 688.217992,99 C711.993016,99 696.143,115 719.918024,115 C743.693047,115 717.936772,115 735.768039,115 C753.599307,115 743.197734,115 767.468071,115 C791.738407,115 783.318087,99 807.588423,99 C831.85876,99 815.513431,99 839.288455,99 C863.063478,99 854.147844,83 886.343189,83 C918.538533,83 907.146335,83 942.313557,83 C977.480779,83 965.593268,99 989.368291,99 C1013.14331,99 1060.69336,99 1084.46839,99 C1108.24341,99 1092.39339,83 1124.09343,83 C1145.22678,83 1166.36013,83 1187.49349,83 C1196.73933,83 1209.28726,83 1225.13728,83 C1248.9123,83 1255.86036,99 1274.66857,99 C1293.47679,99 1289.58034,99 1322.21862,99 C1354.8569,99 1338.06864,115 1361.84366,115 C1385.61869,115 1377.69368,115 1401.4687,115 C1425.24372,115 1420.27121,99 1433.16873,99 C1441.76708,99 1447.71083,99 1451,99 L1451,157 L11,157 C11,97 11,67 11,67 Z",
            fill: "#E1EBF9",
            className: "fill-primary5"
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(92.500000, 95.000000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "0",
                  y: "2",
                  width: "28",
                  height: "60"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "28",
                  y: "2",
                  width: "20",
                  height: "60"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M0,2 L0,0 L48,0 L48,2 L0,2 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "54",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "30",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "46",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "22",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "46",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "22",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "38",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "14",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "38",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "30",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "6",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "20",
                  y: "6",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "6",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "14",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "12",
                  y: "54",
                  width: "4",
                  height: "8"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "20",
                  y: "54",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "20",
                  y: "30",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "22",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "40",
                  y: "22",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "20",
                  y: "46",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "20",
                  y: "22",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "14",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "40",
                  y: "14",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "20",
                  y: "38",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "20",
                  y: "14",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "6",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "40",
                  y: "6",
                  width: "4",
                  height: "4"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(127.500000, 85.000000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M36,12 L36,0 L64,0 L64,12 L52,12 L52,24 L40,24 L40,36 L28,36 L28,72 L0,72 L0,36 L12,36 L12,24 L24,24 L24,12 L36,12 Z",
                  fill: "#D8E5F8",
                  className: "fill-primary10"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M64,12 L64,0 L76,0 L76,72 L28,72 L28,36 L40,36 L40,24 L52,24 L52,12 L64,12 Z",
                  fill: "#D0DDF9",
                  className: "fill-primary20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "40",
                  width: "8",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "16",
                  y: "28",
                  width: "8",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "28",
                  y: "16",
                  width: "8",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "40",
                  y: "4",
                  width: "8",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "48",
                  width: "8",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "56",
                  width: "8",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "16",
                  y: "40",
                  width: "8",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "28",
                  y: "28",
                  width: "8",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "40",
                  y: "16",
                  width: "8",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "52",
                  y: "4",
                  width: "8",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "40",
                  width: "8",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "56",
                  y: "28",
                  width: "8",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "44",
                  y: "28",
                  width: "8",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "56",
                  y: "16",
                  width: "8",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M70,4 C71.1045695,4 72,4.8954305 72,6 L72,12 L72,12 L68,12 L68,6 C68,4.8954305 68.8954305,4 70,4 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "68",
                  y: "16",
                  width: "4",
                  height: "16"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "16",
                  y: "48",
                  width: "8",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "48",
                  width: "8",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "16",
                  y: "56",
                  width: "8",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "56",
                  width: "8",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "16",
                  y: "64",
                  width: "8",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "64",
                  width: "8",
                  height: "4"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(192.500000, 69.000000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "0",
                  y: "32",
                  width: "20",
                  height: "56"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  points: "20 20 40 20 20 32 0 32"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M20,88 L20,32 L40,20 L40,0 L60,0 L60,88 L20,88 Z",
                  fill: "#D0DDF9",
                  className: "fill-primary20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "36",
                  width: "4",
                  height: "48"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "24",
                  y: "36",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "24",
                  y: "44",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "24",
                  y: "52",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "24",
                  y: "60",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-1"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-1"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-2"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-2"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "36",
                  width: "4",
                  height: "48"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "36",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "44",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "52",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "60",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-3"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-3"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-4"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "20",
                  y: "0",
                  width: "20",
                  height: "20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "24",
                  y: "4",
                  width: "4",
                  height: "16"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "44",
                  y: "4",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "44",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "44",
                  y: "20",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "44",
                  y: "28",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-5"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-5"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-6"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-6"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-7"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-7"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-8"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-8"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-9"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-9"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-10"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-10"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "32",
                  y: "4",
                  width: "4",
                  height: "16"
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-11"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-11"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-12"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-12"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-13"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-13"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-14"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-14"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-15"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-15"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-16"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-16"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-17"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-17"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-18"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-18"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-19"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-19"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-20"
                  })]
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(322.000000, 0.000000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "0",
                  y: "4",
                  width: "40",
                  height: "124"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  transform: "translate(20.000000, 2.000000) scale(1, -1) translate(-20.000000, -2.000000) ",
                  x: "8",
                  y: "0",
                  width: "24",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M32,4 L32,0 L48,0 L48,4 L56,4 L56,128 L40,128 L40,4 L32,4 Z",
                  fill: "#C3D5F5",
                  className: "fill-primary20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "12",
                  width: "8",
                  height: "108"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "16",
                  y: "12",
                  width: "8",
                  height: "108"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "28",
                  y: "12",
                  width: "8",
                  height: "108"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "4",
                  y: "12",
                  width: "8",
                  height: "28"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "16",
                  y: "12",
                  width: "8",
                  height: "28"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "28",
                  y: "12",
                  width: "8",
                  height: "28"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "44",
                  y: "12",
                  width: "8",
                  height: "108"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(244.000000, 23.000000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "0",
                  y: "0",
                  width: "48",
                  height: "124"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "48",
                  y: "0",
                  width: "20",
                  height: "124"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "16",
                  width: "38",
                  height: "100"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  points: "4 44 4 32 42 56 42 68"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  points: "4 53 4 48 42 72 42 77"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "52",
                  y: "16",
                  width: "12",
                  height: "100"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "4",
                  y: "6",
                  width: "16",
                  height: "6"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(342.500000, 69.000000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  points: "0 1.08052456e-13 28 1.08052456e-13 28 68 0 68"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "28",
                  y: "0",
                  width: "12",
                  height: "68"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "8",
                  width: "20",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "16",
                  width: "4",
                  height: "40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "20",
                  y: "16",
                  width: "4",
                  height: "40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "16",
                  width: "4",
                  height: "40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "8",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "16",
                  width: "4",
                  height: "32"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(382.500000, 83.500000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  points: "0 1.08052456e-13 28 1.08052456e-13 28 68 0 68"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "28",
                  y: "0",
                  width: "12",
                  height: "68"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "8",
                  width: "20",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "16",
                  width: "4",
                  height: "40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "20",
                  y: "16",
                  width: "4",
                  height: "40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "16",
                  width: "4",
                  height: "40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "8",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "16",
                  width: "4",
                  height: "32"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(269.000000, 77.500000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "0",
                  y: "0",
                  width: "20",
                  height: "56"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "0",
                  y: "8",
                  width: "20",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "0",
                  y: "16",
                  width: "20",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "0",
                  y: "24",
                  width: "20",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "0",
                  y: "32",
                  width: "20",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "0",
                  y: "40",
                  width: "20",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "0",
                  y: "48",
                  width: "20",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "20",
                  y: "0",
                  width: "16",
                  height: "56"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "20",
                  y: "8",
                  width: "16",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "20",
                  y: "16",
                  width: "16",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "20",
                  y: "24",
                  width: "16",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "20",
                  y: "32",
                  width: "16",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "20",
                  y: "40",
                  width: "16",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "20",
                  y: "48",
                  width: "16",
                  height: "4"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(444.000000, 101.000000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "0",
                  y: "0",
                  width: "20",
                  height: "56"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "0",
                  y: "8",
                  width: "20",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "0",
                  y: "16",
                  width: "20",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "0",
                  y: "24",
                  width: "20",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "0",
                  y: "32",
                  width: "20",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "0",
                  y: "40",
                  width: "20",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "0",
                  y: "48",
                  width: "20",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "20",
                  y: "0",
                  width: "16",
                  height: "56"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "20",
                  y: "8",
                  width: "16",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "20",
                  y: "16",
                  width: "16",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "20",
                  y: "24",
                  width: "16",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "20",
                  y: "32",
                  width: "16",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "20",
                  y: "40",
                  width: "16",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "20",
                  y: "48",
                  width: "16",
                  height: "4"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(224.500000, 101.000000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M32,36 L32,56 L12,56 L12,36 L32,36 Z M44,0 L44,36 L32,36 L32,0 L44,0 Z",
                  fill: "#C3D5F5",
                  className: "fill-primary20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M56,36 L56,8 L68,8 L68,56 L48,56 L48,36 L56,36 Z",
                  fill: "#C3D5F5",
                  className: "fill-primary20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "12",
                  y: "0",
                  width: "20",
                  height: "36"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "0",
                  y: "36",
                  width: "20",
                  height: "20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "28",
                  y: "36",
                  width: "20",
                  height: "20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "36",
                  y: "8",
                  width: "20",
                  height: "28"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "16",
                  y: "4",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "16",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "40",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "16",
                  y: "20",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "40",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "32",
                  y: "40",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "40",
                  y: "20",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "16",
                  y: "28",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "48",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "32",
                  y: "48",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "40",
                  y: "28",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "24",
                  y: "4",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "24",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "48",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "60",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "24",
                  y: "20",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "40",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "40",
                  y: "40",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "48",
                  y: "20",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "60",
                  y: "20",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "24",
                  y: "28",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "48",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "40",
                  y: "48",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "48",
                  y: "28",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "60",
                  y: "28",
                  width: "4",
                  height: "4"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(513.000000, 101.000000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M32,36 L32,56 L12,56 L12,36 L32,36 Z M44,0 L44,36 L32,36 L32,0 L44,0 Z",
                  fill: "#C3D5F5",
                  className: "fill-primary20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M56,36 L56,8 L68,8 L68,56 L48,56 L48,36 L56,36 Z",
                  fill: "#C3D5F5",
                  className: "fill-primary20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "12",
                  y: "0",
                  width: "20",
                  height: "36"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "0",
                  y: "36",
                  width: "20",
                  height: "20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "28",
                  y: "36",
                  width: "20",
                  height: "20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "36",
                  y: "8",
                  width: "20",
                  height: "28"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "16",
                  y: "4",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "16",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "40",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "16",
                  y: "20",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "40",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "32",
                  y: "40",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "40",
                  y: "20",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "16",
                  y: "28",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "48",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "32",
                  y: "48",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "40",
                  y: "28",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "24",
                  y: "4",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "24",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "48",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "60",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "24",
                  y: "20",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "40",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "40",
                  y: "40",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "48",
                  y: "20",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "60",
                  y: "20",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "24",
                  y: "28",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "48",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "40",
                  y: "48",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "48",
                  y: "28",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "60",
                  y: "28",
                  width: "4",
                  height: "4"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(280.500000, 101.000000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M32,36 L32,56 L12,56 L12,36 L32,36 Z M44,0 L44,36 L32,36 L32,0 L44,0 Z",
                  fill: "#C3D5F5",
                  className: "fill-primary20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M56,36 L56,8 L68,8 L68,56 L48,56 L48,36 L56,36 Z",
                  fill: "#C3D5F5",
                  className: "fill-primary20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "12",
                  y: "0",
                  width: "20",
                  height: "36"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "0",
                  y: "36",
                  width: "20",
                  height: "20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "28",
                  y: "36",
                  width: "20",
                  height: "20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "36",
                  y: "8",
                  width: "20",
                  height: "28"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "16",
                  y: "4",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "16",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "40",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "16",
                  y: "20",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "40",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "32",
                  y: "40",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "40",
                  y: "20",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "16",
                  y: "28",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "48",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "32",
                  y: "48",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "40",
                  y: "28",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "24",
                  y: "4",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "24",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "48",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "60",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "24",
                  y: "20",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "40",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "40",
                  y: "40",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "48",
                  y: "20",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "60",
                  y: "20",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "24",
                  y: "28",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "48",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "40",
                  y: "48",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "48",
                  y: "28",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "60",
                  y: "28",
                  width: "4",
                  height: "4"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(348.500000, 129.000000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "0",
                  y: "0",
                  width: "28",
                  height: "28"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "28",
                  y: "0",
                  width: "12",
                  height: "28"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "20",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "4",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "4",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "12",
                  y: "20",
                  width: "4",
                  height: "8"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "20",
                  y: "20",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "20",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "20",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "20",
                  y: "4",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "4",
                  width: "4",
                  height: "4"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(398.500000, 65.000000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "0",
                  y: "20",
                  width: "20",
                  height: "56"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  points: "20 0 40 0 20 20 0 20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  points: "20 20 40 0 40 20 40 76 20 76"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "24",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "24",
                  y: "24",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "32",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "24",
                  y: "32",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "40",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "24",
                  y: "40",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "48",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "24",
                  y: "48",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "56",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "24",
                  y: "56",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "64",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "24",
                  y: "64",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "24",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "24",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "32",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "32",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "40",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "40",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "48",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "48",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "56",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "56",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "64",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "64",
                  width: "4",
                  height: "4"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(485.500000, 81.000000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "0",
                  y: "20",
                  width: "20",
                  height: "56"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  points: "20 0 40 0 20 20 0 20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  points: "20 20 40 0 40 20 40 76 20 76"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "24",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "24",
                  y: "24",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "32",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "24",
                  y: "32",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "40",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "24",
                  y: "40",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "48",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "24",
                  y: "48",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "56",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "24",
                  y: "56",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "64",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "24",
                  y: "64",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "24",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "24",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "32",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "32",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "40",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "40",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "48",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "48",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "56",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "56",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "64",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "64",
                  width: "4",
                  height: "4"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(56.000000, 121.000000) scale(-1, 1) translate(-56.000000, -121.000000) translate(14.000000, 97.000000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D0DDF9",
                  className: "fill-primary20",
                  x: "0",
                  y: "24",
                  width: "36",
                  height: "24"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "36",
                  y: "24",
                  width: "12",
                  height: "24"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "48",
                  y: "24",
                  width: "12",
                  height: "12"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "60",
                  y: "24",
                  width: "12",
                  height: "12"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "72",
                  y: "24",
                  width: "12",
                  height: "12"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M6,32 C7.1045695,32 8,32.8954305 8,34 L8,36 L8,36 L4,36 L4,34 C4,32.8954305 4.8954305,32 6,32 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M48,48 L48,36 L60,24 L60,36 L72,24 L72,36 L84,24 L84,48 L48,48 Z",
                  fill: "#D8E5F8",
                  className: "fill-primary10"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M6,40 C7.1045695,40 8,40.8954305 8,42 L8,44 L8,44 L4,44 L4,42 C4,40.8954305 4.8954305,40 6,40 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M14,32 C15.1045695,32 16,32.8954305 16,34 L16,36 L16,36 L12,36 L12,34 C12,32.8954305 12.8954305,32 14,32 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M14,40 C15.1045695,40 16,40.8954305 16,42 L16,44 L16,44 L12,44 L12,42 C12,40.8954305 12.8954305,40 14,40 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M22,32 C23.1045695,32 24,32.8954305 24,34 L24,36 L24,36 L20,36 L20,34 C20,32.8954305 20.8954305,32 22,32 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M22,40 C23.1045695,40 24,40.8954305 24,42 L24,44 L24,44 L20,44 L20,42 C20,40.8954305 20.8954305,40 22,40 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M30,32 C31.1045695,32 32,32.8954305 32,34 L32,36 L32,36 L28,36 L28,34 C28,32.8954305 28.8954305,32 30,32 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M30,40 C31.1045695,40 32,40.8954305 32,42 L32,44 L32,44 L28,44 L28,42 C28,40.8954305 28.8954305,40 30,40 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M42,40 C43.1045695,40 44,40.8954305 44,42 L44,44 L44,44 L40,44 L40,42 C40,40.8954305 40.8954305,40 42,40 Z",
                  fill: "#C3D5F5",
                  className: "fill-primary20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M54,40 C55.1045695,40 56,40.8954305 56,42 L56,48 L56,48 L52,48 L52,42 C52,40.8954305 52.8954305,40 54,40 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M66,40 C67.1045695,40 68,40.8954305 68,42 L68,48 L68,48 L64,48 L64,42 C64,40.8954305 64.8954305,40 66,40 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M78,40 C79.1045695,40 80,40.8954305 80,42 L80,48 L80,48 L76,48 L76,42 C76,40.8954305 76.8954305,40 78,40 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M42,32 C43.1045695,32 44,32.8954305 44,34 L44,36 L44,36 L40,36 L40,34 C40,32.8954305 40.8954305,32 42,32 Z",
                  fill: "#C3D5F5",
                  className: "fill-primary20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  points: "30 0 32 0 32 24 28 24"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  points: "16 0 18 0 18 24 14 24"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#D0DDF9",
                  className: "fill-primary20",
                  points: "32 0 34 0 36 24 32 24"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#D0DDF9",
                  className: "fill-primary20",
                  points: "18 0 20 0 22 24 18 24"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(612.500000, 91.500000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "32",
                  y: "12",
                  width: "12",
                  height: "40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M20,52 L20,32 L44,32 L44,12 L56,12 L56,52 L20,52 Z",
                  fill: "#D0DDF9",
                  className: "fill-primary20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#D0DDF9",
                  className: "fill-primary20",
                  points: "44 0 44 12 32 12"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  cx: "38",
                  cy: "18",
                  r: "2"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  cx: "50",
                  cy: "18",
                  r: "2"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  points: "44 0 56 12 44 12"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  points: "0 32 10 24 20 32 20 52 0 52"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  points: "10 24 38 24 48 32 20 32"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M10,40 C11.1045695,40 12,40.8954305 12,42 L12,52 L12,52 L8,52 L8,42 C8,40.8954305 8.8954305,40 10,40 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M26,36 C27.1045695,36 28,36.8954305 28,38 L28,48 L28,48 L24,48 L24,38 C24,36.8954305 24.8954305,36 26,36 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M34,36 C35.1045695,36 36,36.8954305 36,38 L36,48 L36,48 L32,48 L32,38 C32,36.8954305 32.8954305,36 34,36 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M42,36 C43.1045695,36 44,36.8954305 44,38 L44,48 L44,48 L40,48 L40,38 C40,36.8954305 40.8954305,36 42,36 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "8",
                  y: "32",
                  width: "4",
                  height: "4",
                  rx: "2"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(388.000000, 127.000000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "0",
                  y: "2",
                  width: "28",
                  height: "28"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "28",
                  y: "2",
                  width: "12",
                  height: "28"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M0,2 L0,0 L40,0 L40,2 L0,2 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "22",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "14",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "14",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "6",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "6",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "12",
                  y: "22",
                  width: "4",
                  height: "8"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "20",
                  y: "22",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "22",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "20",
                  y: "14",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "14",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "20",
                  y: "6",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "6",
                  width: "4",
                  height: "4"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(172.000000, 121.000000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "0",
                  y: "2",
                  width: "28",
                  height: "28"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "28",
                  y: "2",
                  width: "12",
                  height: "28"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M0,2 L0,0 L40,0 L40,2 L0,2 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "22",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "14",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "14",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "6",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "6",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "12",
                  y: "22",
                  width: "4",
                  height: "8"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "20",
                  y: "22",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "22",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "20",
                  y: "14",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "14",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "20",
                  y: "6",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "6",
                  width: "4",
                  height: "4"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(29.500000, 127.000000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "0",
                  y: "2",
                  width: "28",
                  height: "28"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "28",
                  y: "2",
                  width: "12",
                  height: "28"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M0,2 L0,0 L40,0 L40,2 L0,2 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "22",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "14",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "14",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "6",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "6",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "12",
                  y: "22",
                  width: "4",
                  height: "8"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "20",
                  y: "22",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "22",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "20",
                  y: "14",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "14",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "20",
                  y: "6",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "6",
                  width: "4",
                  height: "4"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(576.500000, 127.000000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "0",
                  y: "2",
                  width: "28",
                  height: "28"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "28",
                  y: "2",
                  width: "12",
                  height: "28"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M0,2 L0,0 L40,0 L40,2 L0,2 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "22",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "14",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "14",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "6",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "6",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "12",
                  y: "22",
                  width: "4",
                  height: "8"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "20",
                  y: "22",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "22",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "20",
                  y: "14",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "14",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "20",
                  y: "6",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "6",
                  width: "4",
                  height: "4"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(422.500000, 137.000000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  points: "6 0 34 0 28 8 0 8"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M14,2 L20,8 L28,8 L28,20 L0,20 L0,8 L8,8 L14,2 Z",
                  fill: "#D8E5F8",
                  className: "fill-primary10"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  points: "28 8 34 0 40 8 40 20 28 20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "20",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "12",
                  y: "12",
                  width: "4",
                  height: "8"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#A1BBF3",
                  className: "fill-primary40",
                  transform: "translate(20.000000, 5.000000) rotate(-180.000000) translate(-20.000000, -5.000000) ",
                  points: "20 2 26 8 14 8"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(150.500000, 137.000000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  points: "6 0 34 0 28 8 0 8"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M14,2 L20,8 L28,8 L28,20 L0,20 L0,8 L8,8 L14,2 Z",
                  fill: "#D8E5F8",
                  className: "fill-primary10"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  points: "28 8 34 0 40 8 40 20 28 20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "20",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "12",
                  y: "12",
                  width: "4",
                  height: "8"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#A1BBF3",
                  className: "fill-primary40",
                  transform: "translate(20.000000, 5.000000) rotate(-180.000000) translate(-20.000000, -5.000000) ",
                  points: "20 2 26 8 14 8"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(186.500000, 137.000000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  points: "6 0 34 0 28 8 0 8"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M14,2 L20,8 L28,8 L28,20 L0,20 L0,8 L8,8 L14,2 Z",
                  fill: "#D8E5F8",
                  className: "fill-primary10"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  points: "28 8 34 0 40 8 40 20 28 20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "20",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "12",
                  y: "12",
                  width: "4",
                  height: "8"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#A1BBF3",
                  className: "fill-primary40",
                  transform: "translate(20.000000, 5.000000) rotate(-180.000000) translate(-20.000000, -5.000000) ",
                  points: "20 2 26 8 14 8"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(461.500000, 119.000000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M16,14 L16,2 L52,2 L52,14 L44,14 L44,26 L36,26 L36,38 L0,38 L0,26 L8,26 L8,14 L16,14 Z",
                  fill: "#D8E5F8",
                  className: "fill-primary10"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "16",
                  y: "30",
                  width: "4",
                  height: "8"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "30",
                  width: "8",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "24",
                  y: "30",
                  width: "8",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M44,26 L44,14 L52,14 L52,2 L64,2 L64,38 L36,38 L36,26 L44,26 Z",
                  fill: "#C3D5F5",
                  className: "fill-primary20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "18",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "20",
                  y: "18",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "28",
                  y: "18",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "36",
                  y: "18",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "20",
                  y: "6",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "28",
                  y: "6",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "36",
                  y: "6",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "44",
                  y: "6",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "56",
                  y: "6",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "56",
                  y: "18",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "56",
                  y: "30",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "48",
                  y: "18",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "48",
                  y: "30",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "40",
                  y: "30",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M16,2 L16,0 L64,0 L64,2 L16,2 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(675.000000, 133.000000) scale(-1, 1) translate(-675.000000, -133.000000) translate(633.000000, 109.000000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D0DDF9",
                  className: "fill-primary20",
                  x: "0",
                  y: "24",
                  width: "36",
                  height: "24"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "36",
                  y: "24",
                  width: "12",
                  height: "24"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "48",
                  y: "24",
                  width: "12",
                  height: "12"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "60",
                  y: "24",
                  width: "12",
                  height: "12"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "72",
                  y: "24",
                  width: "12",
                  height: "12"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M6,32 C7.1045695,32 8,32.8954305 8,34 L8,36 L8,36 L4,36 L4,34 C4,32.8954305 4.8954305,32 6,32 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M48,48 L48,36 L60,24 L60,36 L72,24 L72,36 L84,24 L84,48 L48,48 Z",
                  fill: "#D8E5F8",
                  className: "fill-primary10"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M6,40 C7.1045695,40 8,40.8954305 8,42 L8,44 L8,44 L4,44 L4,42 C4,40.8954305 4.8954305,40 6,40 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M14,32 C15.1045695,32 16,32.8954305 16,34 L16,36 L16,36 L12,36 L12,34 C12,32.8954305 12.8954305,32 14,32 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M14,40 C15.1045695,40 16,40.8954305 16,42 L16,44 L16,44 L12,44 L12,42 C12,40.8954305 12.8954305,40 14,40 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M22,32 C23.1045695,32 24,32.8954305 24,34 L24,36 L24,36 L20,36 L20,34 C20,32.8954305 20.8954305,32 22,32 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M22,40 C23.1045695,40 24,40.8954305 24,42 L24,44 L24,44 L20,44 L20,42 C20,40.8954305 20.8954305,40 22,40 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M30,32 C31.1045695,32 32,32.8954305 32,34 L32,36 L32,36 L28,36 L28,34 C28,32.8954305 28.8954305,32 30,32 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M30,40 C31.1045695,40 32,40.8954305 32,42 L32,44 L32,44 L28,44 L28,42 C28,40.8954305 28.8954305,40 30,40 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M42,40 C43.1045695,40 44,40.8954305 44,42 L44,44 L44,44 L40,44 L40,42 C40,40.8954305 40.8954305,40 42,40 Z",
                  fill: "#C3D5F5",
                  className: "fill-primary20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M54,40 C55.1045695,40 56,40.8954305 56,42 L56,48 L56,48 L52,48 L52,42 C52,40.8954305 52.8954305,40 54,40 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M66,40 C67.1045695,40 68,40.8954305 68,42 L68,48 L68,48 L64,48 L64,42 C64,40.8954305 64.8954305,40 66,40 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M78,40 C79.1045695,40 80,40.8954305 80,42 L80,48 L80,48 L76,48 L76,42 C76,40.8954305 76.8954305,40 78,40 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M42,32 C43.1045695,32 44,32.8954305 44,34 L44,36 L44,36 L40,36 L40,34 C40,32.8954305 40.8954305,32 42,32 Z",
                  fill: "#C3D5F5",
                  className: "fill-primary20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  points: "30 0 32 0 32 24 28 24"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  points: "16 0 18 0 18 24 14 24"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#D0DDF9",
                  className: "fill-primary20",
                  points: "32 0 34 0 36 24 32 24"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#D0DDF9",
                  className: "fill-primary20",
                  points: "18 0 20 0 22 24 18 24"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(604.000000, 137.000000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "0",
                  y: "8",
                  width: "20",
                  height: "12"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  points: "6 0 26 0 20 8 0 8"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  points: "20 8 26 0 32 8 32 20 20 20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "24",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "4",
                  y: "12",
                  width: "4",
                  height: "8"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(0.000000, 137.000000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "0",
                  y: "8",
                  width: "20",
                  height: "12"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  points: "6 0 26 0 20 8 0 8"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  points: "20 8 26 0 32 8 32 20 20 20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "24",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "4",
                  y: "12",
                  width: "4",
                  height: "8"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(699.000000, 137.000000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "0",
                  y: "8",
                  width: "20",
                  height: "12"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  points: "6 0 26 0 20 8 0 8"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  points: "20 8 26 0 32 8 32 20 20 20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "24",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "4",
                  y: "12",
                  width: "4",
                  height: "8"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(533.000000, 137.000000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "0",
                  y: "8",
                  width: "44",
                  height: "12"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  points: "6 0 50 0 44 8 0 8"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  points: "44 8 50 0 56 8 56 20 44 20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "24",
                  y: "12",
                  width: "4",
                  height: "8"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "32",
                  y: "12",
                  width: "8",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "12",
                  width: "8",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "48",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "16",
                  y: "12",
                  width: "4",
                  height: "8"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(61.500000, 137.000000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "0",
                  y: "8",
                  width: "44",
                  height: "12"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  points: "6 0 50 0 44 8 0 8"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  points: "44 8 50 0 56 8 56 20 44 20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "24",
                  y: "12",
                  width: "4",
                  height: "8"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "32",
                  y: "12",
                  width: "8",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "12",
                  width: "8",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "48",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "16",
                  y: "12",
                  width: "4",
                  height: "8"
                })]
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
              transform: "translate(731.000000, 0.000000)",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(92.500000, 95.000000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "0",
                  y: "2",
                  width: "28",
                  height: "60"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "28",
                  y: "2",
                  width: "20",
                  height: "60"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M0,2 L0,0 L48,0 L48,2 L0,2 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "54",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "30",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "46",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "22",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "46",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "22",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "38",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "14",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "38",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "30",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "6",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "20",
                  y: "6",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "6",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "14",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "12",
                  y: "54",
                  width: "4",
                  height: "8"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "20",
                  y: "54",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "20",
                  y: "30",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "22",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "40",
                  y: "22",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "20",
                  y: "46",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "20",
                  y: "22",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "14",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "40",
                  y: "14",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "20",
                  y: "38",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "20",
                  y: "14",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "6",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "40",
                  y: "6",
                  width: "4",
                  height: "4"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(127.500000, 85.000000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M36,12 L36,0 L64,0 L64,12 L52,12 L52,24 L40,24 L40,36 L28,36 L28,72 L0,72 L0,36 L12,36 L12,24 L24,24 L24,12 L36,12 Z",
                  fill: "#D8E5F8",
                  className: "fill-primary10"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M64,12 L64,0 L76,0 L76,72 L28,72 L28,36 L40,36 L40,24 L52,24 L52,12 L64,12 Z",
                  fill: "#D0DDF9",
                  className: "fill-primary20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "40",
                  width: "8",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "16",
                  y: "28",
                  width: "8",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "28",
                  y: "16",
                  width: "8",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "40",
                  y: "4",
                  width: "8",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "48",
                  width: "8",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "56",
                  width: "8",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "16",
                  y: "40",
                  width: "8",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "28",
                  y: "28",
                  width: "8",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "40",
                  y: "16",
                  width: "8",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "52",
                  y: "4",
                  width: "8",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "40",
                  width: "8",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "56",
                  y: "28",
                  width: "8",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "44",
                  y: "28",
                  width: "8",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "56",
                  y: "16",
                  width: "8",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M70,4 C71.1045695,4 72,4.8954305 72,6 L72,12 L72,12 L68,12 L68,6 C68,4.8954305 68.8954305,4 70,4 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "68",
                  y: "16",
                  width: "4",
                  height: "16"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "16",
                  y: "48",
                  width: "8",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "48",
                  width: "8",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "16",
                  y: "56",
                  width: "8",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "56",
                  width: "8",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "16",
                  y: "64",
                  width: "8",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "64",
                  width: "8",
                  height: "4"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(192.500000, 69.000000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "0",
                  y: "32",
                  width: "20",
                  height: "56"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  points: "20 20 40 20 20 32 0 32"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M20,88 L20,32 L40,20 L40,0 L60,0 L60,88 L20,88 Z",
                  fill: "#D0DDF9",
                  className: "fill-primary20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "36",
                  width: "4",
                  height: "48"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "24",
                  y: "36",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "24",
                  y: "44",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "24",
                  y: "52",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "24",
                  y: "60",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-21"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-21"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-22"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-22"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "36",
                  width: "4",
                  height: "48"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "36",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "44",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "52",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "60",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-23"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-23"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-24"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-24"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "20",
                  y: "0",
                  width: "20",
                  height: "20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "24",
                  y: "4",
                  width: "4",
                  height: "16"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "44",
                  y: "4",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "44",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "44",
                  y: "20",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "44",
                  y: "28",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-25"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-25"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-26"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-26"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-27"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-27"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-28"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-28"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-29"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-29"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-30"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-30"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "32",
                  y: "4",
                  width: "4",
                  height: "16"
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-31"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-31"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-32"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-32"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-33"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-33"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-34"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-34"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-35"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-35"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-36"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-36"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-37"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-37"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-38"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-38"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-39"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-39"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-40"
                  })]
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(322.000000, 0.000000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "0",
                  y: "4",
                  width: "40",
                  height: "124"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  transform: "translate(20.000000, 2.000000) scale(1, -1) translate(-20.000000, -2.000000) ",
                  x: "8",
                  y: "0",
                  width: "24",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M32,4 L32,0 L48,0 L48,4 L56,4 L56,128 L40,128 L40,4 L32,4 Z",
                  fill: "#C3D5F5",
                  className: "fill-primary20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "12",
                  width: "8",
                  height: "108"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "16",
                  y: "12",
                  width: "8",
                  height: "108"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "28",
                  y: "12",
                  width: "8",
                  height: "108"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "4",
                  y: "12",
                  width: "8",
                  height: "28"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "16",
                  y: "12",
                  width: "8",
                  height: "28"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "28",
                  y: "12",
                  width: "8",
                  height: "28"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "44",
                  y: "12",
                  width: "8",
                  height: "108"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(244.000000, 23.000000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "0",
                  y: "0",
                  width: "48",
                  height: "124"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "48",
                  y: "0",
                  width: "20",
                  height: "124"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "16",
                  width: "38",
                  height: "100"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  points: "4 44 4 32 42 56 42 68"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  points: "4 53 4 48 42 72 42 77"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "52",
                  y: "16",
                  width: "12",
                  height: "100"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "4",
                  y: "6",
                  width: "16",
                  height: "6"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(342.500000, 69.000000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  points: "0 1.08052456e-13 28 1.08052456e-13 28 68 0 68"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "28",
                  y: "0",
                  width: "12",
                  height: "68"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "8",
                  width: "20",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "16",
                  width: "4",
                  height: "40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "20",
                  y: "16",
                  width: "4",
                  height: "40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "16",
                  width: "4",
                  height: "40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "8",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "16",
                  width: "4",
                  height: "32"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(382.500000, 83.500000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  points: "0 1.08052456e-13 28 1.08052456e-13 28 68 0 68"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "28",
                  y: "0",
                  width: "12",
                  height: "68"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "8",
                  width: "20",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "16",
                  width: "4",
                  height: "40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "20",
                  y: "16",
                  width: "4",
                  height: "40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "16",
                  width: "4",
                  height: "40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "8",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "16",
                  width: "4",
                  height: "32"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(269.000000, 77.500000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "0",
                  y: "0",
                  width: "20",
                  height: "56"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "0",
                  y: "8",
                  width: "20",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "0",
                  y: "16",
                  width: "20",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "0",
                  y: "24",
                  width: "20",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "0",
                  y: "32",
                  width: "20",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "0",
                  y: "40",
                  width: "20",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "0",
                  y: "48",
                  width: "20",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "20",
                  y: "0",
                  width: "16",
                  height: "56"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "20",
                  y: "8",
                  width: "16",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "20",
                  y: "16",
                  width: "16",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "20",
                  y: "24",
                  width: "16",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "20",
                  y: "32",
                  width: "16",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "20",
                  y: "40",
                  width: "16",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "20",
                  y: "48",
                  width: "16",
                  height: "4"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(444.000000, 101.000000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "0",
                  y: "0",
                  width: "20",
                  height: "56"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "0",
                  y: "8",
                  width: "20",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "0",
                  y: "16",
                  width: "20",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "0",
                  y: "24",
                  width: "20",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "0",
                  y: "32",
                  width: "20",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "0",
                  y: "40",
                  width: "20",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "0",
                  y: "48",
                  width: "20",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "20",
                  y: "0",
                  width: "16",
                  height: "56"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "20",
                  y: "8",
                  width: "16",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "20",
                  y: "16",
                  width: "16",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "20",
                  y: "24",
                  width: "16",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "20",
                  y: "32",
                  width: "16",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "20",
                  y: "40",
                  width: "16",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "20",
                  y: "48",
                  width: "16",
                  height: "4"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(224.500000, 101.000000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M32,36 L32,56 L12,56 L12,36 L32,36 Z M44,0 L44,36 L32,36 L32,0 L44,0 Z",
                  fill: "#C3D5F5",
                  className: "fill-primary20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M56,36 L56,8 L68,8 L68,56 L48,56 L48,36 L56,36 Z",
                  fill: "#C3D5F5",
                  className: "fill-primary20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "12",
                  y: "0",
                  width: "20",
                  height: "36"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "0",
                  y: "36",
                  width: "20",
                  height: "20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "28",
                  y: "36",
                  width: "20",
                  height: "20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "36",
                  y: "8",
                  width: "20",
                  height: "28"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "16",
                  y: "4",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "16",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "40",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "16",
                  y: "20",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "40",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "32",
                  y: "40",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "40",
                  y: "20",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "16",
                  y: "28",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "48",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "32",
                  y: "48",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "40",
                  y: "28",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "24",
                  y: "4",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "24",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "48",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "60",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "24",
                  y: "20",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "40",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "40",
                  y: "40",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "48",
                  y: "20",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "60",
                  y: "20",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "24",
                  y: "28",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "48",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "40",
                  y: "48",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "48",
                  y: "28",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "60",
                  y: "28",
                  width: "4",
                  height: "4"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(513.000000, 101.000000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M32,36 L32,56 L12,56 L12,36 L32,36 Z M44,0 L44,36 L32,36 L32,0 L44,0 Z",
                  fill: "#C3D5F5",
                  className: "fill-primary20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M56,36 L56,8 L68,8 L68,56 L48,56 L48,36 L56,36 Z",
                  fill: "#C3D5F5",
                  className: "fill-primary20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "12",
                  y: "0",
                  width: "20",
                  height: "36"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "0",
                  y: "36",
                  width: "20",
                  height: "20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "28",
                  y: "36",
                  width: "20",
                  height: "20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "36",
                  y: "8",
                  width: "20",
                  height: "28"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "16",
                  y: "4",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "16",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "40",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "16",
                  y: "20",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "40",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "32",
                  y: "40",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "40",
                  y: "20",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "16",
                  y: "28",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "48",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "32",
                  y: "48",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "40",
                  y: "28",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "24",
                  y: "4",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "24",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "48",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "60",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "24",
                  y: "20",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "40",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "40",
                  y: "40",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "48",
                  y: "20",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "60",
                  y: "20",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "24",
                  y: "28",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "48",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "40",
                  y: "48",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "48",
                  y: "28",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "60",
                  y: "28",
                  width: "4",
                  height: "4"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(280.500000, 101.000000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M32,36 L32,56 L12,56 L12,36 L32,36 Z M44,0 L44,36 L32,36 L32,0 L44,0 Z",
                  fill: "#C3D5F5",
                  className: "fill-primary20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M56,36 L56,8 L68,8 L68,56 L48,56 L48,36 L56,36 Z",
                  fill: "#C3D5F5",
                  className: "fill-primary20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "12",
                  y: "0",
                  width: "20",
                  height: "36"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "0",
                  y: "36",
                  width: "20",
                  height: "20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "28",
                  y: "36",
                  width: "20",
                  height: "20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "36",
                  y: "8",
                  width: "20",
                  height: "28"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "16",
                  y: "4",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "16",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "40",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "16",
                  y: "20",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "40",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "32",
                  y: "40",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "40",
                  y: "20",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "16",
                  y: "28",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "48",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "32",
                  y: "48",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "40",
                  y: "28",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "24",
                  y: "4",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "24",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "48",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "60",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "24",
                  y: "20",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "40",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "40",
                  y: "40",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "48",
                  y: "20",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "60",
                  y: "20",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "24",
                  y: "28",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "48",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "40",
                  y: "48",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "48",
                  y: "28",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "60",
                  y: "28",
                  width: "4",
                  height: "4"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(348.500000, 129.000000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "0",
                  y: "0",
                  width: "28",
                  height: "28"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "28",
                  y: "0",
                  width: "12",
                  height: "28"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "20",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "4",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "4",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "12",
                  y: "20",
                  width: "4",
                  height: "8"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "20",
                  y: "20",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "20",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "20",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "20",
                  y: "4",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "4",
                  width: "4",
                  height: "4"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(398.500000, 65.000000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "0",
                  y: "20",
                  width: "20",
                  height: "56"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  points: "20 0 40 0 20 20 0 20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  points: "20 20 40 0 40 20 40 76 20 76"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "24",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "24",
                  y: "24",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "32",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "24",
                  y: "32",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "40",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "24",
                  y: "40",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "48",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "24",
                  y: "48",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "56",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "24",
                  y: "56",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "64",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "24",
                  y: "64",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "24",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "24",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "32",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "32",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "40",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "40",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "48",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "48",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "56",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "56",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "64",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "64",
                  width: "4",
                  height: "4"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(485.500000, 81.000000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "0",
                  y: "20",
                  width: "20",
                  height: "56"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  points: "20 0 40 0 20 20 0 20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  points: "20 20 40 0 40 20 40 76 20 76"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "24",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "24",
                  y: "24",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "32",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "24",
                  y: "32",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "40",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "24",
                  y: "40",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "48",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "24",
                  y: "48",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "56",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "24",
                  y: "56",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "64",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "24",
                  y: "64",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "24",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "24",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "32",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "32",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "40",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "40",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "48",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "48",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "56",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "56",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "64",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "64",
                  width: "4",
                  height: "4"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(56.000000, 121.000000) scale(-1, 1) translate(-56.000000, -121.000000) translate(14.000000, 97.000000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D0DDF9",
                  className: "fill-primary20",
                  x: "0",
                  y: "24",
                  width: "36",
                  height: "24"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "36",
                  y: "24",
                  width: "12",
                  height: "24"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "48",
                  y: "24",
                  width: "12",
                  height: "12"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "60",
                  y: "24",
                  width: "12",
                  height: "12"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "72",
                  y: "24",
                  width: "12",
                  height: "12"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M6,32 C7.1045695,32 8,32.8954305 8,34 L8,36 L8,36 L4,36 L4,34 C4,32.8954305 4.8954305,32 6,32 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M48,48 L48,36 L60,24 L60,36 L72,24 L72,36 L84,24 L84,48 L48,48 Z",
                  fill: "#D8E5F8",
                  className: "fill-primary10"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M6,40 C7.1045695,40 8,40.8954305 8,42 L8,44 L8,44 L4,44 L4,42 C4,40.8954305 4.8954305,40 6,40 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M14,32 C15.1045695,32 16,32.8954305 16,34 L16,36 L16,36 L12,36 L12,34 C12,32.8954305 12.8954305,32 14,32 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M14,40 C15.1045695,40 16,40.8954305 16,42 L16,44 L16,44 L12,44 L12,42 C12,40.8954305 12.8954305,40 14,40 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M22,32 C23.1045695,32 24,32.8954305 24,34 L24,36 L24,36 L20,36 L20,34 C20,32.8954305 20.8954305,32 22,32 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M22,40 C23.1045695,40 24,40.8954305 24,42 L24,44 L24,44 L20,44 L20,42 C20,40.8954305 20.8954305,40 22,40 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M30,32 C31.1045695,32 32,32.8954305 32,34 L32,36 L32,36 L28,36 L28,34 C28,32.8954305 28.8954305,32 30,32 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M30,40 C31.1045695,40 32,40.8954305 32,42 L32,44 L32,44 L28,44 L28,42 C28,40.8954305 28.8954305,40 30,40 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M42,40 C43.1045695,40 44,40.8954305 44,42 L44,44 L44,44 L40,44 L40,42 C40,40.8954305 40.8954305,40 42,40 Z",
                  fill: "#C3D5F5",
                  className: "fill-primary20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M54,40 C55.1045695,40 56,40.8954305 56,42 L56,48 L56,48 L52,48 L52,42 C52,40.8954305 52.8954305,40 54,40 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M66,40 C67.1045695,40 68,40.8954305 68,42 L68,48 L68,48 L64,48 L64,42 C64,40.8954305 64.8954305,40 66,40 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M78,40 C79.1045695,40 80,40.8954305 80,42 L80,48 L80,48 L76,48 L76,42 C76,40.8954305 76.8954305,40 78,40 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M42,32 C43.1045695,32 44,32.8954305 44,34 L44,36 L44,36 L40,36 L40,34 C40,32.8954305 40.8954305,32 42,32 Z",
                  fill: "#C3D5F5",
                  className: "fill-primary20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  points: "30 0 32 0 32 24 28 24"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  points: "16 0 18 0 18 24 14 24"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#D0DDF9",
                  className: "fill-primary20",
                  points: "32 0 34 0 36 24 32 24"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#D0DDF9",
                  className: "fill-primary20",
                  points: "18 0 20 0 22 24 18 24"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(612.500000, 91.500000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "32",
                  y: "12",
                  width: "12",
                  height: "40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M20,52 L20,32 L44,32 L44,12 L56,12 L56,52 L20,52 Z",
                  fill: "#D0DDF9",
                  className: "fill-primary20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#D0DDF9",
                  className: "fill-primary20",
                  points: "44 0 44 12 32 12"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  cx: "38",
                  cy: "18",
                  r: "2"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  cx: "50",
                  cy: "18",
                  r: "2"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  points: "44 0 56 12 44 12"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  points: "0 32 10 24 20 32 20 52 0 52"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  points: "10 24 38 24 48 32 20 32"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M10,40 C11.1045695,40 12,40.8954305 12,42 L12,52 L12,52 L8,52 L8,42 C8,40.8954305 8.8954305,40 10,40 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M26,36 C27.1045695,36 28,36.8954305 28,38 L28,48 L28,48 L24,48 L24,38 C24,36.8954305 24.8954305,36 26,36 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M34,36 C35.1045695,36 36,36.8954305 36,38 L36,48 L36,48 L32,48 L32,38 C32,36.8954305 32.8954305,36 34,36 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M42,36 C43.1045695,36 44,36.8954305 44,38 L44,48 L44,48 L40,48 L40,38 C40,36.8954305 40.8954305,36 42,36 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "8",
                  y: "32",
                  width: "4",
                  height: "4",
                  rx: "2"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(388.000000, 127.000000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "0",
                  y: "2",
                  width: "28",
                  height: "28"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "28",
                  y: "2",
                  width: "12",
                  height: "28"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M0,2 L0,0 L40,0 L40,2 L0,2 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "22",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "14",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "14",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "6",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "6",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "12",
                  y: "22",
                  width: "4",
                  height: "8"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "20",
                  y: "22",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "22",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "20",
                  y: "14",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "14",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "20",
                  y: "6",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "6",
                  width: "4",
                  height: "4"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(172.000000, 121.000000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "0",
                  y: "2",
                  width: "28",
                  height: "28"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "28",
                  y: "2",
                  width: "12",
                  height: "28"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M0,2 L0,0 L40,0 L40,2 L0,2 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "22",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "14",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "14",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "6",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "6",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "12",
                  y: "22",
                  width: "4",
                  height: "8"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "20",
                  y: "22",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "22",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "20",
                  y: "14",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "14",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "20",
                  y: "6",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "6",
                  width: "4",
                  height: "4"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(29.500000, 127.000000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "0",
                  y: "2",
                  width: "28",
                  height: "28"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "28",
                  y: "2",
                  width: "12",
                  height: "28"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M0,2 L0,0 L40,0 L40,2 L0,2 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "22",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "14",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "14",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "6",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "6",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "12",
                  y: "22",
                  width: "4",
                  height: "8"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "20",
                  y: "22",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "22",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "20",
                  y: "14",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "14",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "20",
                  y: "6",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "6",
                  width: "4",
                  height: "4"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(576.500000, 127.000000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "0",
                  y: "2",
                  width: "28",
                  height: "28"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "28",
                  y: "2",
                  width: "12",
                  height: "28"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M0,2 L0,0 L40,0 L40,2 L0,2 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "22",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "14",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "14",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "6",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "6",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "12",
                  y: "22",
                  width: "4",
                  height: "8"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "20",
                  y: "22",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "22",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "20",
                  y: "14",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "14",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "20",
                  y: "6",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "6",
                  width: "4",
                  height: "4"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(422.500000, 137.000000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  points: "6 0 34 0 28 8 0 8"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M14,2 L20,8 L28,8 L28,20 L0,20 L0,8 L8,8 L14,2 Z",
                  fill: "#D8E5F8",
                  className: "fill-primary10"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  points: "28 8 34 0 40 8 40 20 28 20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "20",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "12",
                  y: "12",
                  width: "4",
                  height: "8"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#A1BBF3",
                  className: "fill-primary40",
                  transform: "translate(20.000000, 5.000000) rotate(-180.000000) translate(-20.000000, -5.000000) ",
                  points: "20 2 26 8 14 8"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(150.500000, 137.000000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  points: "6 0 34 0 28 8 0 8"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M14,2 L20,8 L28,8 L28,20 L0,20 L0,8 L8,8 L14,2 Z",
                  fill: "#D8E5F8",
                  className: "fill-primary10"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  points: "28 8 34 0 40 8 40 20 28 20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "20",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "12",
                  y: "12",
                  width: "4",
                  height: "8"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#A1BBF3",
                  className: "fill-primary40",
                  transform: "translate(20.000000, 5.000000) rotate(-180.000000) translate(-20.000000, -5.000000) ",
                  points: "20 2 26 8 14 8"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(186.500000, 137.000000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  points: "6 0 34 0 28 8 0 8"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M14,2 L20,8 L28,8 L28,20 L0,20 L0,8 L8,8 L14,2 Z",
                  fill: "#D8E5F8",
                  className: "fill-primary10"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  points: "28 8 34 0 40 8 40 20 28 20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "20",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "32",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "12",
                  y: "12",
                  width: "4",
                  height: "8"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#A1BBF3",
                  className: "fill-primary40",
                  transform: "translate(20.000000, 5.000000) rotate(-180.000000) translate(-20.000000, -5.000000) ",
                  points: "20 2 26 8 14 8"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(461.500000, 119.000000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M16,14 L16,2 L52,2 L52,14 L44,14 L44,26 L36,26 L36,38 L0,38 L0,26 L8,26 L8,14 L16,14 Z",
                  fill: "#D8E5F8",
                  className: "fill-primary10"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "16",
                  y: "30",
                  width: "4",
                  height: "8"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "30",
                  width: "8",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "24",
                  y: "30",
                  width: "8",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M44,26 L44,14 L52,14 L52,2 L64,2 L64,38 L36,38 L36,26 L44,26 Z",
                  fill: "#C3D5F5",
                  className: "fill-primary20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "18",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "20",
                  y: "18",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "28",
                  y: "18",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "36",
                  y: "18",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "20",
                  y: "6",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "28",
                  y: "6",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "36",
                  y: "6",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "44",
                  y: "6",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "56",
                  y: "6",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "56",
                  y: "18",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "56",
                  y: "30",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "48",
                  y: "18",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "48",
                  y: "30",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "40",
                  y: "30",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M16,2 L16,0 L64,0 L64,2 L16,2 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(675.000000, 133.000000) scale(-1, 1) translate(-675.000000, -133.000000) translate(633.000000, 109.000000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D0DDF9",
                  className: "fill-primary20",
                  x: "0",
                  y: "24",
                  width: "36",
                  height: "24"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "36",
                  y: "24",
                  width: "12",
                  height: "24"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "48",
                  y: "24",
                  width: "12",
                  height: "12"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "60",
                  y: "24",
                  width: "12",
                  height: "12"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "72",
                  y: "24",
                  width: "12",
                  height: "12"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M6,32 C7.1045695,32 8,32.8954305 8,34 L8,36 L8,36 L4,36 L4,34 C4,32.8954305 4.8954305,32 6,32 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M48,48 L48,36 L60,24 L60,36 L72,24 L72,36 L84,24 L84,48 L48,48 Z",
                  fill: "#D8E5F8",
                  className: "fill-primary10"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M6,40 C7.1045695,40 8,40.8954305 8,42 L8,44 L8,44 L4,44 L4,42 C4,40.8954305 4.8954305,40 6,40 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M14,32 C15.1045695,32 16,32.8954305 16,34 L16,36 L16,36 L12,36 L12,34 C12,32.8954305 12.8954305,32 14,32 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M14,40 C15.1045695,40 16,40.8954305 16,42 L16,44 L16,44 L12,44 L12,42 C12,40.8954305 12.8954305,40 14,40 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M22,32 C23.1045695,32 24,32.8954305 24,34 L24,36 L24,36 L20,36 L20,34 C20,32.8954305 20.8954305,32 22,32 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M22,40 C23.1045695,40 24,40.8954305 24,42 L24,44 L24,44 L20,44 L20,42 C20,40.8954305 20.8954305,40 22,40 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M30,32 C31.1045695,32 32,32.8954305 32,34 L32,36 L32,36 L28,36 L28,34 C28,32.8954305 28.8954305,32 30,32 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M30,40 C31.1045695,40 32,40.8954305 32,42 L32,44 L32,44 L28,44 L28,42 C28,40.8954305 28.8954305,40 30,40 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M42,40 C43.1045695,40 44,40.8954305 44,42 L44,44 L44,44 L40,44 L40,42 C40,40.8954305 40.8954305,40 42,40 Z",
                  fill: "#C3D5F5",
                  className: "fill-primary20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M54,40 C55.1045695,40 56,40.8954305 56,42 L56,48 L56,48 L52,48 L52,42 C52,40.8954305 52.8954305,40 54,40 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M66,40 C67.1045695,40 68,40.8954305 68,42 L68,48 L68,48 L64,48 L64,42 C64,40.8954305 64.8954305,40 66,40 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M78,40 C79.1045695,40 80,40.8954305 80,42 L80,48 L80,48 L76,48 L76,42 C76,40.8954305 76.8954305,40 78,40 Z",
                  fill: "#A0BCF0",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M42,32 C43.1045695,32 44,32.8954305 44,34 L44,36 L44,36 L40,36 L40,34 C40,32.8954305 40.8954305,32 42,32 Z",
                  fill: "#C3D5F5",
                  className: "fill-primary20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  points: "30 0 32 0 32 24 28 24"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  points: "16 0 18 0 18 24 14 24"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#D0DDF9",
                  className: "fill-primary20",
                  points: "32 0 34 0 36 24 32 24"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#D0DDF9",
                  className: "fill-primary20",
                  points: "18 0 20 0 22 24 18 24"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(604.000000, 137.000000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "0",
                  y: "8",
                  width: "20",
                  height: "12"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  points: "6 0 26 0 20 8 0 8"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  points: "20 8 26 0 32 8 32 20 20 20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "24",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "4",
                  y: "12",
                  width: "4",
                  height: "8"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(0.000000, 137.000000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "0",
                  y: "8",
                  width: "20",
                  height: "12"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  points: "6 0 26 0 20 8 0 8"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  points: "20 8 26 0 32 8 32 20 20 20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "24",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "4",
                  y: "12",
                  width: "4",
                  height: "8"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(699.000000, 137.000000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "0",
                  y: "8",
                  width: "20",
                  height: "12"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  points: "6 0 26 0 20 8 0 8"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  points: "20 8 26 0 32 8 32 20 20 20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "12",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "24",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "4",
                  y: "12",
                  width: "4",
                  height: "8"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(533.000000, 137.000000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "0",
                  y: "8",
                  width: "44",
                  height: "12"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  points: "6 0 50 0 44 8 0 8"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  points: "44 8 50 0 56 8 56 20 44 20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "24",
                  y: "12",
                  width: "4",
                  height: "8"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "32",
                  y: "12",
                  width: "8",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "12",
                  width: "8",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "48",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "16",
                  y: "12",
                  width: "4",
                  height: "8"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(61.500000, 137.000000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#D8E5F8",
                  className: "fill-primary10",
                  x: "0",
                  y: "8",
                  width: "44",
                  height: "12"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  points: "6 0 50 0 44 8 0 8"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  points: "44 8 50 0 56 8 56 20 44 20"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "24",
                  y: "12",
                  width: "4",
                  height: "8"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "32",
                  y: "12",
                  width: "8",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#C3D5F5",
                  className: "fill-primary20",
                  x: "4",
                  y: "12",
                  width: "8",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "48",
                  y: "12",
                  width: "4",
                  height: "4"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#A0BCF0",
                  className: "fill-primary40",
                  x: "16",
                  y: "12",
                  width: "4",
                  height: "8"
                })]
              })]
            })]
          })]
        })
      })
    })]
  });
};
var _default = exports.default = (0, _withIllustration.default)('IllustrationHousesBackground')(IllustrationHousesBackground);